// extracted by mini-css-extract-plugin
export var active = "footer-module--active--62706";
export var dark = "footer-module--dark--d4c87";
export var icon = "footer-module--icon--82bee";
export var left = "footer-module--left--16fd7";
export var link = "footer-module--link--b2f1a";
export var links = "footer-module--links--f3782";
export var right = "footer-module--right--f5f1a";
export var split = "footer-module--split--56ee5";